import React from 'react';
import { useT } from '@repo/common';

const EmptyLikedWorkshop = () => {
  const t = useT();
  return (
    <div className='flex flex-col justify-center items-center p-10 h-[204px]'>
      <div className='pb-6 w-[570px] flex items-center justify-center text-text-placeholder'>
        {t('No liked workshops', '아직 찜한 워크숍이 없습니다')}
      </div>
    </div>
  );
};

export default EmptyLikedWorkshop;
